import { createApp } from 'vue';
import App from './App.vue';
import { router } from "./classes/Router";
import PrimeVue from 'primevue/config';
import { DialogService, ToastService } from "primevue";
import { root, type InputTextDesignTokens } from "@primeuix/themes/aura/inputtext";


const app = createApp(App);
const config = {
  globalProperties: {
    $primevue: {
      config: {
        theme: {
          preset: {
            name: 'aura',
            root: root as InputTextDesignTokens,
            colorScheme: {
              primary: '#007ad9',
              secondary: '#6c757d',
              success: '#28a745',
              info: '#17a2b8',
              warning: '#ffc107',
              danger: '#dc3545',
            }
          },
          options: {
            prefix: 'p',
            darkModeSelector: 'dark',
            cssLayer: false
          },

        },
        ripple: true,
        locale: {
          startsWith: 'Empieza con',
          contains: 'Contiene',
          notContains: 'No contiene',
          endsWith: 'Termina con',
          equals: 'Igual a',
          notEquals: 'No igual a',
          noFilter: 'Sin filtro',
          lt: 'Menor que',
          lte: 'Menor o igual que',
          gt: 'Mayor que',
          gte: 'Mayor o igual que',
          dateIs: 'Fecha es',
          dateIsNot: 'Fecha no es',
          dateBefore: 'Fecha antes de',
          dateAfter: 'Fecha después de',
          clear: 'Limpiar',
          apply: 'Aplicar',
          matchAll: 'Coincidir con todo',
          matchAny: 'Coincidir con cualquiera',
          addRule: 'Añadir regla',
          removeRule: 'Eliminar regla',
          accept: 'Aceptar',
          reject: 'Rechazar',
          choose: 'Elegir',
          upload: 'Subir',
          cancel: 'Cancelar',
          dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
          dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
          dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
          monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          chooseYear: 'Elegir año',
          chooseMonth: 'Elegir mes',
          chooseDate: 'Elegir fecha',
          completed: 'Completado',
          pending: 'Pendiente',
          fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          nextDecade: 'Próxima década',
          prevDecade: 'Década anterior',
          dateFormat: 'dd/mm/yy',
          prevYear: 'Año anterior',
          weak: 'Débil',
          medium: 'Medio',
          strong: 'Fuerte',
          passwordPrompt: 'Ingrese una contraseña',
          emptyFilterMessage: 'No se encontraron resultados',
          emptyMessage: 'No hay datos disponibles',
          aria: {
            trueLabel: 'Verdadero',
            falseLabel: 'Falso',
            nullLabel: 'Nulo',
            star: 'Estrella',
            stars: "Estrellas",
            selectAll: 'Seleccionar todo',
            unselectAll: 'Deseleccionar todo',
            close: 'Cerrar',
            previous: 'Anterior',
            next: 'Siguiente',
            jumpToPageInputLabel: 'Ir a página',
            pageLabel: "Etiqueta de página",
            cancelEdit: 'Cancelar edición',
            saveEdit: 'Guardar edición',
            editRow: 'Editar fila',
            hideFilterMenu: 'Ocultar menú de filtro',
            collapseRow: 'Colapsar fila',
            expandRow: 'Expandir fila',
            filterConstraint: 'Restricción de filtro',
            filterOperator: 'Operador de filtro',
            firstPageLabel: 'Primera página',
            jumpToPageDropdownLabel: 'Ir a página',
            gridView: 'Vista de cuadrícula',
            listView: 'Vista de lista',
            lastPageLabel: 'Última página',
            nextPageLabel: 'Página siguiente',
            listLabel: 'Lista',
            moveAllToSource: 'Mover todo a origen',
            moveAllToTarget: 'Mover todo a destino',
            moveDown: 'Mover hacia abajo',
            moveToSource: 'Mover a origen',
            moveToTarget: 'Mover a destino',
            moveBottom: 'Mover al final',
            moveUp: 'Mover hacia arriba',
            moveTop: 'Mover al principio',
            rowsPerPageLabel: 'Filas por página',
            scrollTop: 'Desplazar hacia arriba',
            selectRow: 'Seleccionar fila',
            navigation: 'Navegación',
            unselectRow: 'Deseleccionar fila',
            showFilterMenu: 'Mostrar menú de filtro',
            rotateRight: 'Rotar a la derecha',
            rotateLeft: 'Rotar a la izquierda',
            zoomImage: 'Ampliar imagen',
            zoomIn: 'Acercar',
            zoomOut: 'Alejar',
            slide: 'Deslizar',
            slideNumber: 'Número de diapositiva',
            prevPageLabel: 'Página anterior',
          }
        }
      }
    }
  },
  performance: true,
  optionMergeStrategies: {},
  isNativeTag: (tag: string) => tag.startsWith('p-') || tag.startsWith('primevue-'),
  compilerOptions: { comments: true, delimiters: ['[[', ']]'], whitespace: "condense" },
};


app.use(PrimeVue, config)
  .use(router)
  .use(ToastService)
  .use(DialogService)
  .mount('#app');
